
const mAccessDeniedStatusName = new WeakMap();
const mBaseData = new WeakMap();
const mAccessDeniedCount = new WeakMap();
const mTrackerLiveStreamCount = new WeakMap();

class ReportEventStatistics {
    constructor(accessDeniedStatusName) {
        mAccessDeniedStatusName.set(this, accessDeniedStatusName);
        mBaseData.set(this, new Map());
        mAccessDeniedCount.set(this, 0);
        mTrackerLiveStreamCount.set(this, 0);
    }

    get accessDeniedCount() {
        return mAccessDeniedCount.get(this);
    }

    get trackerLiveStreamCount() {
        return mTrackerLiveStreamCount.get(this);
    }

    set trackerLiveStreamCount(updatedCount) {
        mTrackerLiveStreamCount.set(this, updatedCount);
    }

    get eventCount() {
        return mBaseData.get(this).size;
    }

    reset() {
        mBaseData.get(this).clear();
        mAccessDeniedCount.set(this, 0);
        mTrackerLiveStreamCount.set(this, 0);
    }

    addEvent(evt) {
        if (evt != null) {
            if (!(mBaseData.get(this)).has(evt.trackingEventId)) {
                (mBaseData.get(this)).set(evt.trackingEventId, evt.statusName);
                if (evt.statusName === (mAccessDeniedStatusName.get(this))) {
                    let currentAccessDeniedCount = mAccessDeniedCount.get(this);
                    mAccessDeniedCount.set(this, currentAccessDeniedCount + 1);
                }
            }
        }
    }
}

export default ReportEventStatistics;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-reports/report-models/ReportEventStatistics.js
// module id = hYzA
// module chunks = 1